module.exports = __webpack_public_path__ + "media/images/siq-modal-thank-you-13111558a796deb0799e4c3df058debc.png";